"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styles = require("./styles.scss");

var _styles2 = _interopRequireDefault(_styles);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function (_React$Component) {
  (0, _inherits3.default)(Header, _React$Component);

  function Header() {
    (0, _classCallCheck3.default)(this, Header);
    return (0, _possibleConstructorReturn3.default)(this, (Header.__proto__ || (0, _getPrototypeOf2.default)(Header)).apply(this, arguments));
  }

  (0, _createClass3.default)(Header, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _props = this.props,
          children = _props.children,
          className = _props.className;


      return _react2.default.createElement(
        "header",
        { className: (0, _classnames2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, _styles2.default.header, true), (0, _defineProperty3.default)(_classNames, className, !!className), _classNames)) },
        _react2.default.createElement(
          "h1",
          null,
          children
        )
      );
    }
  }]);
  return Header;
}(_react2.default.Component);

var Content = function (_React$Component2) {
  (0, _inherits3.default)(Content, _React$Component2);

  function Content() {
    (0, _classCallCheck3.default)(this, Content);
    return (0, _possibleConstructorReturn3.default)(this, (Content.__proto__ || (0, _getPrototypeOf2.default)(Content)).apply(this, arguments));
  }

  (0, _createClass3.default)(Content, [{
    key: "render",
    value: function render() {
      var _classNames2;

      var _props2 = this.props,
          children = _props2.children,
          className = _props2.className;


      return _react2.default.createElement(
        "div",
        { className: (0, _classnames2.default)((_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, _styles2.default.popupBoxInner, true), (0, _defineProperty3.default)(_classNames2, className, !!className), _classNames2)) },
        children
      );
    }
  }]);
  return Content;
}(_react2.default.Component);

var Footer = function (_React$Component3) {
  (0, _inherits3.default)(Footer, _React$Component3);

  function Footer() {
    (0, _classCallCheck3.default)(this, Footer);
    return (0, _possibleConstructorReturn3.default)(this, (Footer.__proto__ || (0, _getPrototypeOf2.default)(Footer)).apply(this, arguments));
  }

  (0, _createClass3.default)(Footer, [{
    key: "render",
    value: function render() {
      var _classNames3;

      var _props3 = this.props,
          children = _props3.children,
          className = _props3.className;


      return _react2.default.createElement(
        "div",
        { className: (0, _classnames2.default)((_classNames3 = {}, (0, _defineProperty3.default)(_classNames3, _styles2.default.footer, true), (0, _defineProperty3.default)(_classNames3, className, !!className), _classNames3)) },
        children
      );
    }
  }]);
  return Footer;
}(_react2.default.Component);

var Popup = function (_React$Component4) {
  (0, _inherits3.default)(Popup, _React$Component4);

  function Popup() {
    (0, _classCallCheck3.default)(this, Popup);
    return (0, _possibleConstructorReturn3.default)(this, (Popup.__proto__ || (0, _getPrototypeOf2.default)(Popup)).apply(this, arguments));
  }

  (0, _createClass3.default)(Popup, [{
    key: "render",
    value: function render() {
      var _classNames4;

      var _props4 = this.props,
          children = _props4.children,
          className = _props4.className;


      return _react2.default.createElement(
        "section",
        { className: (0, _classnames2.default)((_classNames4 = {}, (0, _defineProperty3.default)(_classNames4, _styles2.default.popupBox, true), (0, _defineProperty3.default)(_classNames4, className, !!className), _classNames4)) },
        children
      );
    }
  }]);
  return Popup;
}(_react2.default.Component);

Popup.Header = Header;
Popup.Content = Content;
Popup.Footer = Footer;
exports.default = Popup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Popup/Popup.jsx
// module id = 440
// module chunks = 0